/* istanbul ignore file */

import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { Filter } from '../components/Filter';
import { actions as filterActions } from '../modules/slice';

const mapStateToProps = ({ filter: { filterModal }, products }: ReduxApplicationState) => ({
  isModalOpen: filterModal.isModalOpen,
  error: products.error,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  closeFilterModal: () => dispatch(filterActions.closeModal()),
  onShowList: () => dispatch(filterActions.showList()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export type FilterContainerProps = ConnectedProps<typeof connector>;

export const FilterContainer = connector(Filter);
